var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavUsdt = function SvgNavUsdt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NavUsdt_svg__tether-(usdt)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "NavUsdt_svg__Vector",
    d: "M6.225 2.79167H13.775C14.6583 2.79167 15.7 3.43333 16.0917 4.225L18.0917 8.24167C18.575 9.20833 18.3083 10.5833 17.5167 11.3083L11.7417 16.55C10.7833 17.4167 9.225 17.4167 8.26667 16.55L2.49167 11.3083C1.69167 10.5833 1.43333 9.20833 1.91667 8.24167L3.91667 4.225C4.3 3.43333 5.34167 2.79167 6.225 2.79167Z",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavUsdt_svg__Vector_2",
    d: "M10 12.0833V7.08333",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavUsdt_svg__Vector_3",
    d: "M6.66667 7.08333H13.3333",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }))));
};
export default SvgNavUsdt;